<script>
    import { imask } from 'svelte-imask';
    import { format, isValid } from "date-fns";
    import { parseDateInput, clampDate } from "../../utils/parseDateInput";

    export let value;
    export let maxDateString;
    export let minDateString;
    export let isDisabled = false;
    export let errorText = "";
    export let name = "";
    export let handleChange;
    export let placeholder = "";
    export let formattedString = "";
    export let containerClass = "";
    export let fieldName;

    const dateMask = { mask: '00/00/0000' };

    const toDisplayString = (isoDate) =>
        isoDate && isValid(new Date(isoDate)) ? format(new Date(isoDate), "dd/MM/yyyy") : "";

    function commit(type) {
        handleChange?.({ type, target: { name, value } });
    }

    // Never writes back to the input: a half-typed date leaves the previous value in place.
    function handleTextInput(e) {
        const parsed = parseDateInput(e.target.value);

        if (parsed === null) {
            return;
        }

        value = parsed;
        commit(e.type);
    }

    // Leaving the field is the only moment we're allowed to rewrite what the user sees.
    function handleTextBlur(e) {
        if (!e.target.value) {
            value = "";
        } else {
            value = clampDate(value, minDateString, maxDateString);
        }

        e.target.value = toDisplayString(value);
        commit(e.type);
    }

    $: formattedString = toDisplayString(value);

</script>

<div class="flex flex-col w-full">
    {#if !!fieldName}
        <div class="font-450 text-lg">{fieldName}</div>
    {/if}

    <div class="w-full relative">
        <input
            class="h-10 borderless-input absolute top-2 left-2 {isDisabled && 'bg-gray-100'}"
            style="width: calc(100% - 5rem)"
            type="text"
            placeholder={placeholder}
            disabled={isDisabled}
            use:imask={dateMask}
            value={formattedString}
            name="{name}"
            on:input={handleTextInput}
            on:blur={handleTextBlur}
        >

        <input
            class="w-full input-home h-11 {errorText ? 'border-error' : ''} {containerClass} {isDisabled && 'bg-gray-100'}"
            type="date"
            min={minDateString}
            max={maxDateString}
            name={name}
            placeholder={placeholder}
            disabled={isDisabled}
            bind:value={value}
            on:change={handleChange}
            on:blur={handleChange}
        >

        {#if !!errorText}
            <div class="pl-3 text-red-500">
                {errorText}
            </div>
        {/if}
    </div>
</div>



<style>
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    .top-2 {
        top: 2px;
    }

    .borderless-input {
        border: none;
    }

    .borderless-input:focus {
        border: transparent;
        box-shadow: none;
    }
</style>
